import { render, staticRenderFns } from "./analysisManbingTableRenshu.vue?vue&type=template&id=a006ff46"
import script from "./analysisManbingTableRenshu.vue?vue&type=script&lang=js"
export * from "./analysisManbingTableRenshu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports